'use client';

import Link from 'next/link';
import { FC } from 'react';

import * as S from './SubFooterLink.styles';

type Props = { path: string; name: string };

export const SubFooterLink: FC<Props> = ({ path, name }) => {
  return (
    <S.FooterLink as={Link} href={path} prefetch={false}>
      {name}
    </S.FooterLink>
  );
};
